import React from 'react'

function WorkPresentationImage(props){

    return(
        <section id="WorkPresentation" className="section project-images">
            <div className="container-fluid-small">
                <div className="row">
                    <div className="col-12 col-sm-12 col-md-12 presentation-image">
                        {props.presentationImage.map((item, index) => <img className="anim-bot" key={index} src={`assets/images/${item}`} alt="" />)}
                    </div>

                </div>
            </div>
        </section>
    )

}

export default WorkPresentationImage